require('whatwg-fetch')

exports.onClientEntry = () => {
  // Empty export to make import work.
  // Fetch polyfill required for IE 11 compatability.
}